module.exports = {
  "account_page": [
    {
      "language": "en-US",
      "slug": "/account",
      "robots": "noindex,nofollow"
    }
  ],
  "shopping_cart_page": [
    {
      "language": "en-US",
      "slug": "/shopping-cart",
      "robots": "index,follow"
    }
  ],
  "not_found_page": [
    {
      "language": "en-US",
      "slug": "/not-found",
      "robots": "index,follow"
    }
  ]
}